import { Avatar } from "ui/components/avatar";

import { RenderAvatar } from "../render-avatar";
import classNames from "classnames";
import { formatName } from "utils";

export function UserCell({ getValue, className }) {
    const user = getValue()

    return (
        <span className="flex gap-2 items-center">
            <Avatar className={classNames("size-7 rounded-full", className)}>
                <RenderAvatar user={user} alt={user?.first_name} />
            </Avatar>
            {formatName(user)}
        </span>
    );
}
